// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"wrapper__uMbHh","chart":"chart__29gSk"};


//////////////////
// WEBPACK FOOTER
// ./src/components/PieChart/styles.scss
// module id = 2141
// module chunks = 1